<template>
  <div class="app-container">
    <div class="filter-container">
      <el-form ref="queryForm" inline :model="listQuery" @submit.native.prevent>
        <el-form-item prop="title">
          <el-input
            v-model="listQuery.title"
            placeholder="请输入标题"
            clearable
            @keyup.enter.native="SearchData"
          />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="SearchData"
            >搜索</el-button
          >
          <el-button icon="el-icon-refresh" @click="resetQuery">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
    <!--动作组-->
    <div class="action-container">
      <el-button-group>
        <!-- 弹窗层编辑 -->
        <el-button
          v-auth="'Banner.create'"
          class="action-item"
          type="primary"
          icon="el-icon-edit"
          @click="HandleCreate"
          >添加</el-button
        >
        <el-button
          v-auth="'Banner.delete'"
          class="action-item"
          icon="el-icon-delete"
          @click="BatchDelete"
          >删除</el-button
        >
      </el-button-group>
    </div>
    <!--表开始-->
    <el-table
      ref="singleTable"
      v-loading="listLoading"
      :data="list"
      border
      fit
      highlight-current-row
      style="width: 100%"
      @sort-change="sortChange"
    >
      <!--列开始-->
      <!-- <el-table-column type="selection"></el-table-column> -->
      <el-table-column type="selection"></el-table-column>
      <el-table-column
        type="index"
        label="序号"
        width="55"
        :index="indexMethod"
        align="center"
      />
      <el-table-column align="center" prop="title" label="标题">
      </el-table-column>
      <el-table-column align="center" label="图片" width="330">
        <template slot-scope="{ row }">
          <el-image
            style="width: 300px; height: 100px"
            :src="row.img_url_attachment"
            :preview-src-list="[row.img_url_attachment]"
          ></el-image>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="status" label="状态">
        <template slot-scope="{ row }">
          <el-tag v-if="row.status == 1" type="success">显示</el-tag>
          <el-tag v-if="row.status == 2" type="danger">隐藏</el-tag>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="order_no" label="排序" sortable>
      </el-table-column>
      <el-table-column
        align="center"
        prop="create_time"
        width="180"
        label="添加时间"
        sortable
      ></el-table-column>
      <el-table-column
        align="center"
        prop=""
        label="操作"
        width="200"
        class-name="action"
      >
        <template slot-scope="scopes">
          <el-button
            v-auth="'Banner.edit'"
            type="text"
            plain
            icon="el-icon-edit"
            size="mini"
            @click="HandleUpdate(scopes.row)"
          >
            编辑
          </el-button>
          <el-button
            v-auth="'Banner.delete'"
            type="text"
            plain
            icon="el-icon-delete"
            size="mini"
            @click="RowDelete(scopes.row)"
          >
            删除
          </el-button>
        </template>
      </el-table-column>
      <!--列结束-->
    </el-table>
    <!--分页-->
    <pagination
      v-show="total > 0"
      :total="total"
      :page.sync="listQuery.page"
      :limit.sync="listQuery.limit"
      @pagination="loadData"
    />

    <!--弹窗编辑/新增窗体-->
    <el-dialog
      :title="dialogStatus == 'create' ? '新增' : '编辑'"
      :visible.sync="dialogFormVisible"
    >
      <el-form
        ref="dataForm"
        :rules="rules"
        :model="temp"
        label-width="110px"
        style="width: 100%;"
      >
        <el-form-item label="标题" prop="title">
          <el-input v-model="temp.title" />
        </el-form-item>
        <el-form-item label="图片" prop="img_url_attachment">
          <FileList
            v-model="temp.img_url_attachment"
            :item-width="360"
            :item-height="150"
            :limit="1"
            type="image"
          />
        </el-form-item>
        <el-form-item label="类型" prop="type">
          <el-radio-group v-model="temp.type">
            <el-radio :label="1">纯图片</el-radio>
            <el-radio :label="2">跳转外链</el-radio>
            <el-radio :label="3">跳转站内文章</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item v-if="temp.type == 2" label="外链" prop="temp.link">
          <el-input v-model="temp.link" placeholder="请输入内容"> </el-input>
        </el-form-item>

        <el-form-item v-if="temp.type == 3" label="文章" prop="article_id">
          <SelectArticle v-model="temp.article_id" />
        </el-form-item>

        <el-form-item label="状态" prop="status">
          <el-radio-group v-model="temp.status">
            <el-radio :label="1">显示</el-radio>
            <el-radio :label="2">隐藏</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="显示排序" prop="order_no">
          <span slot="label">
            <el-tooltip content="排序号越小越靠前" placement="top">
              <i class="el-icon-question"></i>
            </el-tooltip>
            显示排序
          </span>
          <el-input-number
            v-model="temp.order_no"
            :min="1"
            :precision="0"
          ></el-input-number>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取消</el-button>
        <el-button type="primary" @click="ConfirmData">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import api from "@/api/banner"; // 和数据交互相关写在api 方便复用
import Pagination from "@/components/Pagination"; // 分页 给予 el-pagination 的二次封装
import commonList from "@/utils/commonList";
import FileList from "@/components/attachment/FileList";
import SelectArticle from "./components/SelectArticle";
export default {
  name: "Banner",
  components: { Pagination, SelectArticle, FileList },
  // 列绑定格式化器
  filters: {},
  mixins: [commonList],
  data() {
    return {
      // api接口方法
      api,
      // 校验
      rules: {
        title: [
          {
            required: true,
            message: "请输入文章名称",
            trigger: ["blur", "change"]
          }
        ],
        img_url_attachment: [
          { required: true, message: "请选择图片", trigger: ["blur", "change"] }
        ],
        type: [
          { required: true, message: "请选择类型", trigger: ["blur", "change"] }
        ],
        article_id: [
          { required: true, message: "请选择文章", trigger: ["blur", "change"] }
        ],
        status: [
          { required: true, message: "请选择状态", trigger: ["blur", "change"] }
        ],
        link: [
          { required: true, message: "请输入外链", trigger: ["blur", "change"] }
        ]
      },
      temp: {},
      listQuery: {
        page: 1,
        limit: 10, // 页大小
        order: "DESC", // 默认排序方式,
        sort: "id",
        type: 1
      }
    };
  },
  created() {
    this.loadData();
  },
  methods: {
    resetTemp() {
      this.temp = {
        id: undefined,
        order_no: 9999,
        type: 1,
        status: 1
      };
    }
  }
};
</script>
